import { z } from 'zod';
import { ASSIGNABLE_DOCUMENT_TYPES } from '../types/documentTemplates.types';

const documentTypeField = z.union([z.literal(''), z.enum(ASSIGNABLE_DOCUMENT_TYPES)]);

const baseShape = {
  dealerId: z.string(),
  documentType: documentTypeField,
  templateId: z.string().min(1, 'Select a template'),
};

export const productSlotAssignmentSchema = z.object(baseShape);

export const dealerOverrideAssignmentSchema = z.object({
  ...baseShape,
  dealerId: z.string().min(1, 'Select a dealer'),
  documentType: z.enum(ASSIGNABLE_DOCUMENT_TYPES, { errorMap: () => ({ message: 'Select a document' }) }),
});
